/**
 * Takes a rich text field from Contentful, parses the number of words, and
 * estimates reading time
 */

import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

const WPM = 170

function getWordCount(text) {
  return text.split(' ').filter(function (word) {
    return word != ''
  }).length
}

export function timeToRead(copy) {
  const text = documentToPlainTextString(copy.json)
  const count = getWordCount(text)
  const minutes = Math.max(parseInt(count / WPM, 10), 1)
  return `${minutes} min`
}
